


















































































































































import { format } from 'date-fns'
import { Component, Vue, Prop } from 'vue-property-decorator'

import { customerOrdersService } from '@plugin/Order/services/customer-orders.service'
import { CustomerOrdersResultsInterface } from '@plugin/Order/interfaces/customer-orders-results.interface'

declare global {
  interface Window {
    storeSettings: any
  }
}
window.storeSettings = window.storeSettings || {}

@Component({
  filters: {
    shortDate(value) {
      return format(new Date(value), 'MMM dd, yyyy')
    },
  },
})
export default class OrderHistory extends Vue {
  private customerOrders: CustomerOrdersResultsInterface | null = null
  private orderDetails: any = {}
  private revealedOrderIds: number[] = []
  private orderIdDetailLoading: number | null = null
  private ordersLoading: boolean = false

  private headers: any[] = [
    {
      text: 'Product',
      value: 'Name',
      sortable: false,
      align: 'start',
    },
    {
      text: 'Assignment',
      value: 'AssignedTo',
      sortable: false,
      align: 'center',
    },
    {
      text: 'Price',
      value: 'Price',
      sortable: false,
      align: 'end',
    },
  ]

  displayAttributes(attributes: any[]) {
    const hiddenAttrList = window.storeSettings?.CatalogSettings?.HiddenAttributes
      ? window.storeSettings.CatalogSettings.HiddenAttributes.split(',')
      : []
    const hiddenAttrListUppercase = hiddenAttrList.map((attr) => attr.toUpperCase())
    const displayAttrs = attributes.filter((attr) => {
      return !hiddenAttrListUppercase.includes(attr.Name.toUpperCase())
    })
    return displayAttrs
  }

  async retrieveCustomerOrders() {
    this.ordersLoading = true
    try {
      this.customerOrders = await customerOrdersService.getCustomerOrders()
    } catch (e) {
      // ... TODO: Handle this error
    }
    this.ordersLoading = false
  }

  async retrieveOrderDetails(id) {
    this.orderIdDetailLoading = id
    const orderDetail = await customerOrdersService.getOrderDetails(id)
    this.orderIdDetailLoading = null
    return orderDetail
  }

  async revealOrderDetails(id) {
    const newRevealedOrders = [id]

    if (this.revealedOrderIds.includes(id)) {
      const removedOrderIdSet = this.revealedOrderIds.filter((oId) => oId !== id)
      this.revealedOrderIds = removedOrderIdSet
    } else {
      if (!this.orderDetails[id]) {
        const orderDetails = await this.retrieveOrderDetails(id)
        const newOrderDetails = {
          ...orderDetails,
          Items: this.convertOrderItems(orderDetails.Items),
        }
        this.orderDetails[id] = newOrderDetails
      }
      this.revealedOrderIds = [...this.revealedOrderIds, ...newRevealedOrders]
    }
  }

  convertOrderItems(orderDetailItems) {
    return orderDetailItems.map((item) => {
      const quantityValue = item.Quantity > 1 ? `${item.Quantity} x ` : ``
      const priceQuantity = `${quantityValue}${item.UnitPriceWithDiscount}`
      const AssignedToMembers = item.CustomProperties?.AssignedTo ?? [];
      const AssignedToList = Array.isArray(AssignedToMembers) ? AssignedToMembers.map((member) => member.Name) : [];


      return {
        Name: item.ProductName,
        Attributes: item.Attributes,
        AssignedTo: AssignedToList,
        DiscountAmount: item.DiscountAmount,
        DiscountPercent: item.DiscountPercent,
        OriginalPrice: item.UnitPrice !== item.UnitPriceWithDiscount && item.UnitPriceValue > 0 ? item.UnitPrice : null,
        Price: priceQuantity,
      }
    })
  }

  isRevealedOrder(id) {
    return this.revealedOrderIds.includes(id)
  }

  mounted() {
    this.retrieveCustomerOrders()
  }
}
